import type { CosmaPackage, CosmaPreviewOrder, CosmaSendBulkError } from "../cosmaApi";
import { PackagesConfirmDialog } from "./PackagesConfirmDialog";

interface CosmaConfirmDialogProps {
  previews: CosmaPreviewOrder[];
  previewErrors: CosmaSendBulkError[];
  sending: boolean;
  sendError: string | null;
  onConfirm: (overrides: Record<string, CosmaPackage[]>) => void;
  onClose: () => void;
}

/**
 * Popup di conferma invio Cosma (spec 2026-06-12). Wrapper thin su
 * `PackagesConfirmDialog` (editor colli condiviso Cosma+WF): qui solo i testi
 * e il prefisso testid `cosma`. `CosmaPreviewOrder`/`CosmaPackage` sono
 * strutturalmente identici ai tipi generici del dialog (assegnabilità diretta).
 */
export function CosmaConfirmDialog({
  previews,
  previewErrors,
  sending,
  sendError,
  onConfirm,
  onClose,
}: CosmaConfirmDialogProps) {
  return (
    <PackagesConfirmDialog
      previews={previews}
      previewErrors={previewErrors}
      sending={sending}
      sendError={sendError}
      onConfirm={onConfirm}
      onClose={onClose}
      testIdPrefix="cosma"
      titleId="cosma-confirm-title"
      title="Confermi l'invio a Cosma?"
      subtitle={(n) =>
        `${n} ordin${n === 1 ? "e" : "i"} — controlla spedizione e colli, poi conferma. Le modifiche ai colli vengono salvate sull'ordine.`
      }
      confirmLabel={(n) => `Conferma e invia (${n})`}
    />
  );
}
